import React from "react"
import PropTypes from "prop-types"
import { Alert, Button } from "reactstrap"

// A profile that could not be read (player, organizer, club): why, by the read's HTTP status, and a Retry. `profile` names it ("club profile").
const profileLoadErrorText = (status, profile) =>
  status === 404
    ? `This ${profile} could not be found.`
    : status === 401
    ? "Your session has expired. Please sign in again."
    : status === 403
    ? `You do not have access to this ${profile}.`
    : "The request could not be completed. Please try again."

const ProfileLoadError = ({ title, profile, status, onRetry }) => (
  <Alert color="danger">
    <div className="font-weight-semibold">{title}</div>
    <p className="mb-2">{profileLoadErrorText(status, profile)}</p>
    <Button color="primary" onClick={onRetry}>Retry</Button>
  </Alert>
)

ProfileLoadError.propTypes = {
  onRetry: PropTypes.func.isRequired,
  profile: PropTypes.string.isRequired,
  status: PropTypes.number,
  title: PropTypes.string.isRequired,
}

export default ProfileLoadError
